import { SETTINGS_ACTION_TYPES } from "./settingsActions";

// Initial State
const initialState = {
    // Company Information
    name: "",
    address: "",
    phoneNumber: "",
    createdDate: null,
    companyLogoUrl: "",
    isAssignedWorkplace: false,
    companyEmail: "",

    // Notification Preferences
    isGetEmailNotifications: true,
    isGetPushNotifications: true,
    isGetWeeklyReports: true,

    // Privacy Settings
    isLeaveTypeHidden: false,
    isCalendarViewHidden: false,
    canViewOtherDepartments: true,

    // Loading and Error States
    loading: false,
    updating: false,
    error: null,
    lastUpdated: null,
};

// Reducer
const settingsReducer = (state = initialState, action) => {
    switch (action.type) {
        case SETTINGS_ACTION_TYPES.FETCH_SETTINGS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case SETTINGS_ACTION_TYPES.FETCH_SETTINGS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                lastUpdated: new Date().toISOString(),
                // Map API response to state
                name: action.payload.name || "",
                address: action.payload.address || "",
                phoneNumber: action.payload.phoneNumber || "",
                createdDate: action.payload.createdDate || null,
                companyLogoUrl: action.payload.companyLogoUrl || "",
                isAssignedWorkplace: action.payload.isAssignedWorkplace || false,
                companyEmail: action.payload.companyEmail || "",
                isGetEmailNotifications: action.payload.isGetEmailNotifications !== undefined ? action.payload.isGetEmailNotifications : true,
                isGetPushNotifications: action.payload.isGetPushNotifications !== undefined ? action.payload.isGetPushNotifications : true,
                isGetWeeklyReports: action.payload.isGetWeeklyReports !== undefined ? action.payload.isGetWeeklyReports : true,
                isLeaveTypeHidden: action.payload.isLeaveTypeHidden !== undefined ? action.payload.isLeaveTypeHidden : false,
                isCalendarViewHidden: action.payload.isCalendarViewHidden !== undefined ? action.payload.isCalendarViewHidden : false,
                canViewOtherDepartments: action.payload.canViewOtherDepartments !== undefined ? action.payload.canViewOtherDepartments : true,
            };

        case SETTINGS_ACTION_TYPES.FETCH_SETTINGS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case SETTINGS_ACTION_TYPES.UPDATE_SETTINGS_REQUEST:
            return {
                ...state,
                updating: true,
                error: null,
            };

        case SETTINGS_ACTION_TYPES.UPDATE_SETTINGS_SUCCESS:
            return {
                ...state,
                updating: false,
                error: null,
                lastUpdated: new Date().toISOString(),
                // Update state with new data
                name: action.payload.name || state.name,
                address: action.payload.address || state.address,
                phoneNumber: action.payload.phoneNumber || state.phoneNumber,
                createdDate: action.payload.createdDate || state.createdDate,
                companyLogoUrl: action.payload.companyLogoUrl || state.companyLogoUrl,
                isAssignedWorkplace: action.payload.isAssignedWorkplace !== undefined ? action.payload.isAssignedWorkplace : state.isAssignedWorkplace,
                companyEmail: action.payload.companyEmail || state.companyEmail,
                isGetEmailNotifications: action.payload.isGetEmailNotifications !== undefined ? action.payload.isGetEmailNotifications : state.isGetEmailNotifications,
                isGetPushNotifications: action.payload.isGetPushNotifications !== undefined ? action.payload.isGetPushNotifications : state.isGetPushNotifications,
                isGetWeeklyReports: action.payload.isGetWeeklyReports !== undefined ? action.payload.isGetWeeklyReports : state.isGetWeeklyReports,
                isLeaveTypeHidden: action.payload.isLeaveTypeHidden !== undefined ? action.payload.isLeaveTypeHidden : state.isLeaveTypeHidden,
                isCalendarViewHidden: action.payload.isCalendarViewHidden !== undefined ? action.payload.isCalendarViewHidden : state.isCalendarViewHidden,
                canViewOtherDepartments: action.payload.canViewOtherDepartments !== undefined ? action.payload.canViewOtherDepartments : state.canViewOtherDepartments,
            };

        case SETTINGS_ACTION_TYPES.UPDATE_SETTINGS_FAILURE:
            return {
                ...state,
                updating: false,
                error: action.payload,
            };

        case SETTINGS_ACTION_TYPES.RESET_SETTINGS:
            return initialState;

        default:
            return state;
    }
};

export default settingsReducer;
